import { atom } from 'jotai'

export const departmentAtom = atom({})
export const departmentPeopleAtom = atom([])
export const productAtom = atom({})
export const serviceAtom = atom({})
export const projectAtom = atom({})
export const mainProjectAtom = atom({})
export const hiringProcessAtom = atom({})
export const purchaseAtom = atom({})